import React from 'react';
import { Navigate, useParams } from 'react-router-dom';

/**
 * Redirects the removed legacy ballot-initiative detail route
 * (/admin/ballot-initiatives/:id) to its Elections replacement, preserving the id.
 */
const LegacyInitiativeDetailRedirect: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/admin-next/elections/initiatives/${id}`} replace />;
};

export default LegacyInitiativeDetailRedirect;
